import * as R from 'ramda';


export default function BulkChangeAssetTypesDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  bulkChangeAssetTypesConfirmDialog
) {
  const vm = this;

  vm.originalCustomerAssetTypeId = -1;
  vm.customerAssetTypeId = -1;

  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkChange = _handleBulkChange;
  vm.handleSelectAll = _handleSelectAll;
  
  activate();

  /** ************************************************
   * Event Handlers
   */

  function activate() {

    vm.originalCustomerAssetTypeId = vm.assetType.customerAssetTypeId;
    vm.customerAssetTypeId = vm.assetType.customerAssetTypeId;

    $scope.$on('selectBulkAssetTypeChange', () => {
      _handleSelectAssetChange();
    });
  }

  function _handleBulkChange($event) {
    if (vm.customerAssetTypeId != vm.originalCustomerAssetTypeId) {
      const _ids = [];

      R.forEach((asset) => {
        if (asset.isBulkChangeType) {
          _ids.push(asset.customerAssetId);
        }
      }, vm.assetType.customerAssets);

      ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesConfirmDialog = ssDialogService.alert(
        bulkChangeAssetTypesConfirmDialog.getOptions($event, {
          customerId: vm.customerId,
          assetIds: _ids,
          newAssetTypeId: vm.customerAssetTypeId,
          updateCallBack: _completeBulkChangeType,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesConfirmDialog);
    } else {
      alerts.error('Please select a new Asset Type.');      
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesDialog);
  }

  function _handleSelectAll() {
    R.forEach((asset) => {
      asset.isBulkChangeType = vm.selectAll;
    }, vm.assetType.customerAssets);
        
    vm.changeIsSelected = vm.selectAll;
  }

  function _handleSelectAssetChange() {
    const selectedIds = [];
    
    R.forEach((item) => {
      if (item.isBulkChangeType === true) {
        selectedIds.push(item.customerAssetId);
      }
    }, vm.assetType.customerAssets);

    vm.changeIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.assetType.customerAssets.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _completeBulkChangeType() {
    $rootScope.$broadcast('refreshAssets', { assetType: { customerAssetTypeId: vm.originalCustomerAssetTypeId } });
    $rootScope.$broadcast('refreshAssets', { assetType: { customerAssetTypeId: vm.customerAssetTypeId } });
    _handleCloseDialog();
  }
}

BulkChangeAssetTypesDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'bulkChangeAssetTypesConfirmDialog',
];
